import { useEffect, useState } from "react";
import { fetchIcon } from "../../../utils/icons";

/**
 * One-shot fetch of the streak icon URL. Mirrors the legacy effect in
 * `art_of_the_day-v2.tsx` lines 536–548. Returns `null` until the fetch
 * resolves; never refetches.
 */
export function useStreakIcon(): URL | null {
  const [icon, setIcon] = useState<URL | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const iconURL = await fetchIcon("STREAK_ICON");
        if (cancelled || !iconURL) return;
        setIcon(new URL(iconURL));
      } catch {
        // non-essential — leave null
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return icon;
}
